import { SET_SECTION_LIST, SET_TABLE_ORDER_DETAILS } from '../types/tableManagement';

const initialState = {
    sectionList: [],
    tableOrderDetails: {},
};

export default function tableManagement(state = initialState, action) {
    switch (action.type) {
        case SET_SECTION_LIST:
            return {
                ...state,
                sectionList: action.payload,
            };
        case SET_TABLE_ORDER_DETAILS:
            return {
                ...state,
                tableOrderDetails: action.payload,
            };
        default:
            return state;
    }
}
